import { api } from './client';
import type {
  DragonStatus,
  DragonSendMode,
  DragonType,
  StartDragonResult,
  FundDragonResult,
  SendDragonResult,
  SetDragonSendModeResult,
  SlayDragonResult,
  CancelDragonResult,
} from '../types/dragon';

export async function getDragonStatus(worldId: string, kingdomId: string): Promise<DragonStatus> {
  const response = await api.get<DragonStatus>(
    `/api/worlds/${worldId}/kingdoms/${kingdomId}/dragon`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to fetch dragon status');
  }
  return response.data;
}

export async function startDragonProject(
  worldId: string,
  provinceId: string,
  targetKingdomId: string,
  dragonType: DragonType,
  sendMode: DragonSendMode
): Promise<StartDragonResult> {
  const response = await api.post<StartDragonResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/dragon/start`,
    { targetKingdomId, dragonType, sendMode }
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to start dragon project');
  }
  return response.data;
}

export async function fundDragon(
  worldId: string,
  provinceId: string,
  amount: number
): Promise<FundDragonResult> {
  const response = await api.post<FundDragonResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/dragon/fund`,
    { amount }
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to fund dragon');
  }
  return response.data;
}

export async function sendDragon(worldId: string, provinceId: string): Promise<SendDragonResult> {
  const response = await api.post<SendDragonResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/dragon/send`,
    {}
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to send dragon');
  }
  return response.data;
}

export async function setDragonSendMode(
  worldId: string,
  provinceId: string,
  sendMode: DragonSendMode
): Promise<SetDragonSendModeResult> {
  const response = await api.post<SetDragonSendModeResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/dragon/send-mode`,
    { sendMode }
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to change send mode');
  }
  return response.data;
}

export async function slayDragon(
  worldId: string,
  provinceId: string,
  soldiers: number,
  specialists: number
): Promise<SlayDragonResult> {
  const response = await api.post<SlayDragonResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/dragon/slay`,
    { soldiers, specialists }
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to attack dragon');
  }
  return response.data;
}

export async function cancelDragon(worldId: string, provinceId: string): Promise<CancelDragonResult> {
  const response = await api.post<CancelDragonResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/dragon/cancel`,
    {}
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to cancel project');
  }
  return response.data;
}
